import axios from "axios";
import {getProject, getToken} from "../helpers/common";

const baseApi = process.env.REACT_APP_API_URL + '/api';
const mailtrainRest = process.env.REACT_APP_MAIL_TRAIN + '/rest/';
const mailtrainApi = process.env.REACT_APP_MAIL_TRAIN + '/api/';

export function cloneTemplate(formData) {
    return axios.post(baseApi + '/email/clone-template', formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}

export function uploadImage(formData) {
    return axios.post(baseApi + '/image/upload-image', formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    });
}

export function validateEmailByExcel(formData) {
    return axios.post(baseApi + '/email/validate-email-by-excel', formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    })
}

export function getEmail(formData) {
    return axios.post(baseApi + '/email/get-email', formData);
}

export function getTemplates() {
    return axios.get(baseApi + '/email/templates/' + getProject());
}

export async function validateEmail(formData) {
    return axios.post(baseApi + '/email/validate-email', formData)
}

export async function createList(name, namespace) {
    return axios.post(mailtrainApi + 'list?access_token=' + getToken(), {
        'NAMESPACE': namespace,
        'UNSUBSCRIPTION_MODE': '0',
        'NAME': name,
        'DESCRIPTION': 'a very nice list',
        'FIELDWIZARD': 'first_last_name',
        'SEND_CONFIGURATION': '1',
        'PUBLIC_SUBSCRIBE': '1',
        'LISTUNSUBSCRIBE_DISABLED': '0'
    });
}

export async function addSubcribe(idList, formData) {
    return axios.post(mailtrainApi + "subscribes/" + idList + "?access_token=" + getToken(), {USERS: JSON.stringify(formData)}, {headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }});
}

export function login(data) {
    return axios.post(mailtrainRest + 'signin', data);
}

export function listTree() {
    return axios.get(mailtrainApi + 'namespaces-tree?access_token=' + getToken());
}

export function createTemplateToMailtrain(formData) {
    return axios.post(mailtrainApi + "templates/store?access_token=" + getToken(), formData);
}

export function listCampaign() {
    return axios.post(mailtrainApi + "campaign/campaigns-status?access_token=" + getToken(), {
        "draw": 1,
        "columns": [
            {
                "data": 1,
                "name": "",
                "searchable": true,
                "orderable": true,
                "search": {
                    "value": "",
                    "regex": false
                }
            },
            {
                "data": 2,
                "name": "",
                "searchable": true,
                "orderable": true,
                "search": {
                    "value": "",
                    "regex": true
                }
            },
            {
                "data": 3,
                "name": "",
                "searchable": true,
                "orderable": true,
                "search": {
                    "value": "",
                    "regex": false
                }
            },
            {
                "data": 4,
                "name": "",
                "searchable": true,
                "orderable": true,
                "search": {
                    "value": "",
                    "regex": false
                }
            },
            {
                "data": 5,
                "name": "",
                "searchable": true,
                "orderable": true,
                "search": {
                    "value": "",
                    "regex": false
                }
            },
            {
                "data": null,
                "name": "",
                "searchable": false,
                "orderable": false,
                "search": {
                    "value": "",
                    "regex": false
                }
            }
        ],
        "order": [
            {
                "column": 0,
                "dir": "asc"
            }
        ],
        "start": 0,
        "search": {
            "value": "",
            "regex": false
        }
    });
}
